"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALL_PROCUREMENT_PERMISSIONS = exports.ProcurementPermissions = void 0;
/**
 * Permission string catalog for Purchase Order (Step 2a), Goods Receipt
 * Note (Step 2b — Pharmacy Procurement & Inventory Engine), and Purchase
 * Requisition (Stage 14 UAT Gap-Fill — precedes a Purchase Order).
 */
exports.ProcurementPermissions = {
    PROCUREMENT_PO_READ: 'procurement-po:read',
    PROCUREMENT_PO_CREATE: 'procurement-po:create',
    PROCUREMENT_PO_UPDATE: 'procurement-po:update',
    PROCUREMENT_PO_SUBMIT: 'procurement-po:submit',
    PROCUREMENT_PO_APPROVE: 'procurement-po:approve',
    PROCUREMENT_PO_SEND_TO_VENDOR: 'procurement-po:send-to-vendor',
    PROCUREMENT_PO_CLOSE: 'procurement-po:close',
    PROCUREMENT_PO_CANCEL: 'procurement-po:cancel',
    PROCUREMENT_GRN_READ: 'procurement-grn:read',
    PROCUREMENT_GRN_CREATE: 'procurement-grn:create',
    PROCUREMENT_GRN_UPDATE: 'procurement-grn:update',
    PROCUREMENT_GRN_POST: 'procurement-grn:post',
    PROCUREMENT_GRN_POST_VENDOR_BILL: 'procurement-grn:post-vendor-bill',
    PROCUREMENT_GRN_CANCEL: 'procurement-grn:cancel',
    // Real feedback — Purchase Return workstation, mirroring InventoryPermissions.INVENTORY_MOVEMENT_RETURN's own posture (a distinct action from GRN_UPDATE, since a return happens after the GRN is already RECEIVED and immutable).
    PROCUREMENT_GRN_RETURN: 'procurement-grn:return',
    PROCUREMENT_REQUISITION_READ: 'procurement-requisition:read',
    PROCUREMENT_REQUISITION_CREATE: 'procurement-requisition:create',
    PROCUREMENT_REQUISITION_SUBMIT: 'procurement-requisition:submit',
    PROCUREMENT_REQUISITION_APPROVE: 'procurement-requisition:approve',
    PROCUREMENT_REQUISITION_CONVERT: 'procurement-requisition:convert',
    PROCUREMENT_REQUISITION_CANCEL: 'procurement-requisition:cancel',
};
exports.ALL_PROCUREMENT_PERMISSIONS = Object.values(exports.ProcurementPermissions);
//# sourceMappingURL=procurement.permissions.js.map